import {
  EMPTY_ARRAY,
  getAgGridColId,
  useDefaultColumns,
  type Column,
  type ColumnDef,
  type FixingIndex,
} from '@talos/kyoko';
import { useMemo } from 'react';

interface UseFixingIndicesColumnsProps {
  defaultColumns?: (keyof FixingIndex | Partial<Column>)[];
}

const DEFAULT_COLUMNS = [
  'Timestamp',
  'IndexID',
  'Name',
  'DisplayName',
  'Asset',
  'QuoteCurrency',
  'ValueType',
  'Revision',
] satisfies (keyof FixingIndex)[];

export function useFixingIndicesColumns({ defaultColumns = DEFAULT_COLUMNS }: UseFixingIndicesColumnsProps) {
  const columnDefinitions = useMemo(
    () =>
      new Map<string, ColumnDef<FixingIndex>>(
        (
          [
            { field: 'Timestamp', type: 'date', title: 'Timestamp', initialSort: '-' },
            { field: 'IndexID', type: 'text', title: 'Index ID', enableRowGroup: true },
            { field: 'Name', type: 'text', title: 'Name' },
            { field: 'DisplayName', type: 'text', title: 'Display Name' },
            { field: 'Asset', type: 'asset', title: 'Asset', enableRowGroup: true },
            { field: 'QuoteCurrency', type: 'currency', title: 'Quote Currency', enableRowGroup: true },
            { field: 'ValueType', type: 'text', title: 'Value Type', enableRowGroup: true },
            { field: 'Revision', type: 'text', title: 'Revision' },
            { field: 'UpdateAction', type: 'text', title: 'Update Action', initialHide: true },
            { field: 'UpdateUserID', type: 'text', title: 'Update User ID', initialHide: true },
            { field: 'Description', type: 'text', title: 'Description', initialHide: true },
          ] satisfies ColumnDef<FixingIndex>[]
        ).map(column => [getAgGridColId(column), column])
      ),
    []
  );

  return useDefaultColumns(defaultColumns ?? EMPTY_ARRAY, columnDefinitions);
}
